import { useFeatureFlag } from '@centecomm/portal-service-react';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoadStatus } from '../../../Types';
import { FeatureFlagActions as Actions, FeatureFlagActionTypes as ActionTypes } from '../actions';
import { featureFlagsLoadStatus } from '../selectors';

export const FeatureFlagsLoader: React.FC<{}> = () => {
    const dispatch = useDispatch();

    const { getFeatures } = useFeatureFlag();

    const featuresLoadStatus = useSelector(featureFlagsLoadStatus);

    React.useEffect(() => {
        if (featuresLoadStatus === LoadStatus.INITIAL_STATE) {
            dispatch({
                type: Actions.LOAD_FEATURE_FLAGS,
            } as ActionTypes);

            getFeatures().then((flags) => {
                dispatch({
                    type: Actions.SET_FEATURE_FLAGS,
                    payload: flags,
                } as ActionTypes);
            });
        }
    }, [featuresLoadStatus]);

    return null;
};
